// extracted by mini-css-extract-plugin
export default {"Version":"Version_Version__qg8UX"};